export class KeyValuesViewModel {
    key: any;
    values: object[];
}